import React from "react";
import { Checkbox, Select } from "antd";
import { IconEE, IconFI, IconLT, IconLV } from "../Layout/Icons";
import Label from "./Label";
import { available_countries } from "../../helpers/GlobalOptions";
import { flag_icons } from "../../helpers/Utils";

const { Option } = Select;

function SelectCountry({
  type,
  value = [],
  onChange,
  error,
  mode = "simple",
  style,
}) {
  if (type == "switch") {
    return (
      <div>
        <Label className="text-sm-label" required={true} error={error}>
          Select countries
        </Label>
        {available_countries
          .filter((d) => d.value !== "ENG")
          .map((d) => {
            const active = value?.includes(d.value);
            const onClick = () => {
              let reValue = Array.isArray(value) ? [...value] : [];
              if (active) {
                reValue = reValue.filter((v) => v !== d.value);
              } else {
                reValue.push(d.value);
              }
              onChange({ target: { name: "countries", value: reValue } });
            };
            return (
              <div
                key={d.value}
                className="mb-2 cursor-pointer"
                style={{
                  background: active ? "#edf9fe" : "#fcfcfc",
                  border: `1px solid ${active ? "#03B0F7" : "#d9d9d9"}`,
                  borderRadius: 4,
                }}
                onClick={onClick}
              >
                <div
                  className={`d-flex align-items-center pl-3 py-2 text-xs text-font font-semi-bold`}
                >
                  <Checkbox checked={active} onClick={onClick} />
                  <span
                    className={`pl-2 text-xs text-font font-semi-bold `}
                    style={{
                      color: active ? "#03b0f7" : "#6C6C6C",
                    }}
                  >
                    {flag_icons[d.value]}
                    {d.label}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    );
  }
  return (
    <div>
      <Label className="text-sm-label">Countries</Label>
      <Select
        mode={mode}
        style={{
          width: "100%",
          ...style,
        }}
        placeholder="Select"
        value={value}
        onChange={(value) => {
          // const sorted = value.sort((a, b) => {
          //   return defaultLangs.indexOf(a) - defaultLangs.indexOf(b);
          // });
          onChange(value);
        }}
      >
        <Option value="LT" label="LT">
          <div className="demo-option-label-item">
            <span className="mr-2" role="img" aria-label="LT">
              <IconLT />
            </span>
            LT
          </div>
        </Option>
        <Option value="LV" label="LV">
          <div className="demo-option-label-item">
            <span className="mr-2" role="img" aria-label="LV">
              <IconLV />
            </span>
            LV
          </div>
        </Option>
        <Option value="EE" label="EE">
          <div className="demo-option-label-item">
            <span className="mr-2" role="img" aria-label="EE">
              <IconEE />
            </span>
            EE
          </div>
        </Option>
        <Option value="FI" label="FI">
          <div className="demo-option-label-item">
            <span className="mr-2" role="img" aria-label="FI">
              <IconFI />
            </span>
            FI
          </div>
        </Option>
      </Select>
    </div>
  );
}

export default SelectCountry;
